import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import { useState } from 'react'
import { removeIdeaFromDeck } from '../apiCalls'
import NewDateFromDeck from '../pages/newDateFromDeck'


const DeckIdeaComp = (props) => {
    const idea = props.mods.value
    const user = props.mods.user
    const deck = props.mods.deck
    const buildDeckIdeaList = props.mods.buildDeckIdeaList
    const getDeck = props.mods.getDeck

    const [detailsToggle, setDetailsToggle] = useState(false)
    const [editToggle, setEditToggle] = useState(false)
    const [newDateToggle, setNewDateToggle] = useState(false)

    function handleDetailsToggle() {
        if (detailsToggle) {
            setDetailsToggle(false)
        } else {
            setDetailsToggle(true)
        }
    }

    function handleEditToggle() {
        if (editToggle === true) {
            setEditToggle(false)
        } else {
            setEditToggle(true)
        }
    }

    function openNewDate() {
        setNewDateToggle(true)
    }

    async function handleRemove() {
        await removeIdeaFromDeck(idea._id, deck._id)
        getDeck(deck._id)
        buildDeckIdeaList()
    }

    return (
        <div className="ideaItem ideaContainer">
            <Container>
                {newDateToggle ? <NewDateFromDeck mods={{setNewDateToggle, idea}} /> : null}
                    <Row>
                        <Col xs={5}>
                            <h4>{idea.name}</h4>
                        </Col>
                        <Col>
                            <Button onClick={openNewDate} className="btn-dark defaultButton altDateButton">Schedule</Button>
                        </Col>
                        <Col xs={2}>
                            <Button className="btn-danger" onClick={handleRemove}><i className="bi bi-x-square bi-danger"></i></Button>
                        </Col>
                    </Row>
                    <Row>
                    <Col>
                        <h6>Location: {idea.location}</h6>
                        {!detailsToggle ? <p type="button" className="bottomCenter" onClick={handleDetailsToggle}>more<i className="bi bi-chevron-compact-down"></i></p> : null}
                    </Col>
                    </Row>
                    {detailsToggle ? 
                        <>
                            <Row>
                                <Col><p>Details: {idea.details}</p></Col>
                                <Col>
                                    {(idea.owner === user._id) ?
                                    <Button className="btn-dark defaultButton editButton position-absolute" onClick={handleEditToggle}>Edit</Button>  : null }
                                    <p type="button" className="bottomCenter" onClick={handleDetailsToggle}>less<i className="bi bi-chevron-compact-up"></i></p>
                                </Col>
                            </Row>
                        
                        </>
                        : null
                    }
                    </Container>
                </div>
    )
}

export default DeckIdeaComp